export default __webpack_public_path__ + "assets/images/adcb128b520cd36964e47428808ecef1.svg";